class BulkScriptsUploadPageTransform {
  constructor() {
    "ngInject";
  }
}

export default BulkScriptsUploadPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bulkScriptsUpload/bulkScriptsUpload.transforms.js